// COSS details stored against each user-line association (attach_to_lines),
// so they can differ on each RT3199. Mirrors App\Helpers\CossLineDetails in the API.
export const COSS_LINE_FIELDS = [
  "limits_site_of_work",
  "nature_of_work_undertaken",
  "ssow_in_use",
  "authority_to_start_iwa_coss_number",
  "authority_to_start_iwa_coss_datetime",
  "iwa_coss_confirm_completed_number",
  "iwa_coss_confirm_completed_datetime",
  "coss_signature_sign_in",
  "coss_signature_sign_out",
];

// The COSS users (internal and external) attached to a line, each with that
// line's own details in place of the user-level ones. A field the line does
// not carry at all falls back to the user.
export const cossAppendicesForLine = (users = {}, lineReference) => {
  if (!lineReference) return [];

  return [...(users.cossusers || []), ...(users.cossXusers || [])].flatMap((user) => {
    const attachedLine = (user.attach_to_lines || []).find((line) => line.line_reference === lineReference);
    if (!attachedLine) return [];

    const lineDetails = Object.fromEntries(
      COSS_LINE_FIELDS.filter((field) => field in attachedLine).map((field) => [field, attachedLine[field]])
    );

    return [{ ...user, ...lineDetails }];
  });
};
